import { render } from "./IconLinkExternal.vue?vue&type=template&id=358b4e14"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLinkExternal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "358b4e14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('358b4e14', __exports__)) {
    api.reload('358b4e14', __exports__)
  }
  
  module.hot.accept("./IconLinkExternal.vue?vue&type=template&id=358b4e14", () => {
    api.rerender('358b4e14', render)
  })

}


export default __exports__